package ru.villawonka.app.presentation.model

import ru.villawonka.app.domain.model.LanguageDomain
import ru.villawonka.app.presentation.screens.variantPicker.model.VariantPickerItemUIModel
import ru.villawonka.app.resources.AppResources

sealed class LanguageUIModel {

    abstract val string: String
    abstract val nativeString: String

    data class Ru(
        override val string: String = AppResources.strings.languageRussian,
        override val nativeString: String = AppResources.strings.languageRussianNative
    ) : LanguageUIModel()

    data class En(
        override val string: String = AppResources.strings.languageEnglish,
        override val nativeString: String = AppResources.strings.languageEnglishNative
    ) : LanguageUIModel()
}

fun LanguageDomain.toUIModel(): LanguageUIModel  = when (this) {
    LanguageDomain.EN -> LanguageUIModel.En()
    LanguageDomain.RU -> LanguageUIModel.Ru()
}

fun LanguageUIModel.toDomainModel(): LanguageDomain = when (this) {
    is LanguageUIModel.En -> LanguageDomain.EN
    is LanguageUIModel.Ru -> LanguageDomain.RU
}

fun LanguageUIModel.toVariantPickerItemUIModel() = VariantPickerItemUIModel(
    title = string,
    subtitle = nativeString
)

fun VariantPickerItemUIModel.toLanguageUIModel(): LanguageUIModel? =
    when (title) {
        AppResources.strings.languageRussian -> LanguageUIModel.Ru()
        AppResources.strings.languageEnglish -> LanguageUIModel.En()
        else -> null
    }